import AppDispatcher from '../../core/AppDispatcher'
import { appActions } from '../AppActions'
import SelectOptionEvent from '../../event/SelectOptionEvent'
import RoomRepository from '../../infra/RoomRepository'

const fetchUserRooms = async () => {
  const response = await RoomRepository.fetchByUser().catch(() => false)
  if (response === false) {
    appActions.showAlert('部屋情報の取得に失敗しました')
    return false
  }

  AppDispatcher.dispatchWithType(SelectOptionEvent.fetchRooms, {
    rooms: response
  })

  return true
}

export default fetchUserRooms
